var Global = {
   // url: 'http://127.0.0.1:8000/api/'
    url: 'http://mysima.grupo-sima.com/api/'
}

export default Global;